export const LANGUAGE_SET: string = 'DOGLEY/LANGUAGE_SET'
